/**
 * THE ONE SENTENCE SOMEBODY READS FIRST.
 *
 * Computed by the backend from the first unmet blocking requirement in stage
 * order. It is the single most important thing on the page: a new employee who
 * reads nothing else should still know what to do next, and the page this
 * replaces could not tell them — it had eleven sections and no opinion about
 * which mattered.
 */
import page from '../../../shared/Page.module.css';
import own from './Onboarding.module.css';
import type { Onboarding, StageId } from './types';

export function NextActionPanel({
  data, onGo, onContact,
}: {
  data: Onboarding;
  onGo: (stage: StageId) => void;
  onContact: (role: string) => void;
}) {
  const { nextAction, ready } = data;
  return (
    <div className={`${own.nextAction} ${ready ? own.nextActionReady : ''}`}>
      <div className={own.nextActionBody}>
        <div className={own.nextActionLabel}>Next action</div>
        <div className={own.nextActionText}>{nextAction.text}</div>
      </div>
      <div className={page.actions}>
        {nextAction.owner === 'customer' && nextAction.contactRole && (
          <button
            type="button"
            className={`${page.btn} ${page.btnPrimary}`}
            onClick={() => onContact(nextAction.contactRole!)}
          >
            Prepare a message
          </button>
        )}
        {!ready && (
          <button
            type="button"
            className={nextAction.owner === 'customer' ? page.btn : `${page.btn} ${page.btnPrimary}`}
            onClick={() => onGo(nextAction.stage)}
          >
            Go to {data.stages.find((s) => s.id === nextAction.stage)?.title ?? 'stage'}
          </button>
        )}
        {ready && (
          <button type="button" className={`${page.btn} ${page.btnPrimary}`} onClick={() => onGo('goLive')}>
            Go to Go live
          </button>
        )}
      </div>
    </div>
  );
}
